<template>
<div class="evaluation_section_selector animate_class" @click="gotoSection">
<div class="grid p-0 m-0">
<div class="col-10 p-0 m-0">
<p class="mt-0 mb-0">{{labeltext}}
<span class="text-green-500 ml-4 font-bold" v-if="show_points">
  <template v-if="sectionpoints!==''">
<template v-if="$store.state.evaluation.evaluation.flow.questionlist.dont_calculate_section_points">
   {{ $store.state.languages.lang_phrases.bolum_basarisi}} {{percentageSuccess}} %
</template>
<template v-else>
  {{sectionpoints}} {{ $store.state.languages.lang_phrases.puan}} 
</template>
 </template>
</span>
</p>
</div>
<div class="col-2 p-0 m-0 flex align-items-center justify-content-end">

 <template v-if="status=='in_progress'">
    <span class="material-icons-outlined md-30 mr-2 text-cyan-500"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.beklemede, disabled: false,class: 'custom-top-tooltip' }"
    >
    mode_standby
    </span>
  </template>
  <template v-if="status=='completed'">
    <span class="material-icons-outlined md-30 mr-2 text-green-400"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }"
    >
    check_circle
    </span>
  </template>
  <template v-if="status=='untouched'">
  <span class="material-icons-outlined md-30 mr-2 text-yellow-400"
  v-tooltip.left="{ value: $store.state.languages.lang_phrases.baslanmadi, disabled: false,class: 'custom-top-tooltip' }"

  >
    not_started
    </span>
</template>

</div>
</div>
</div>
</template>

<script>
export default {
  props:["data"],
  name: 'QuestionlistPreviewSectionSelector',

  data () {
    return {

    }
  },
  computed:{
    percentageSuccess()
    {

        if(this.data.results)
        {
          if(this.data.results.percentage || this.data.results.percentage ===0)
          {
            return this.data.results.percentage
          }
          return this.data.results.points
        }

      
        return null
    },
  	labeltext()
  	{
      //console.log(this.data.translations)
  		let translation = this.data.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      if(translation)
      {
        return translation.translation
      }
      return this.data.name
  		
  	},
    show_points()
    {
      if(this.$store.state.evaluation.evaluation)
      {
        let status = this.$store.state.evaluation.evaluation.status
        if(status=="finished" || status=="correction_requested" || status=="under_review")
        {
          return true
        }
        else
        {
          return false
        }
      }
      return false
      
    },
    sectionpoints()
    {
      //console.log(this.data)
      if(this.data.results)
      {
        return this.data.results.points
      }
      else
      {
        return ""
      }
    },
    status()
    {  
      
      //console.log(this.$store.state.evaluation.sections)
      let inputfields = this.getChildSections(this.data.id) 
     
      console.log(inputfields)
      let completed = 0
      let uncompleted = 0
      for(let item of inputfields)
      {
        if(!item.completion)
        {
          //console.log("completion")
          //console.log(item)
          //console.log(item.completion)
          //console.log(item.show_field)
        }

        if(!item.show_field)
        {
          //console.log("show_field")
          //console.log(item)
          //console.log(item.completion)
          //console.log(item.show_field)
        }
        if(item.completion)
        {
          completed++
        }
        else
        {
          if(item.show_field)
          {
            if(!item.read_only_question)
            {
              uncompleted++
            }
            
          }
          
        }
      }

      if(completed===0)
      {
        return "untouched"
      }
      if(uncompleted===0)
      {
        return "completed"
      }
      if(completed>0 && uncompleted>0)
      {
        return "in_progress"
      }
    },
  },
  methods:{
    getChildSections(parent_id)
    {      
      let sectioninputfields = this.getChildSectionsInputfields(parent_id)
      let child_sections  = this.$store.state.evaluation.sections.filter((item)=>{return item.parent_id == parent_id})
      
      if(child_sections.length)
      {
        for(let child_section of child_sections)
        {
          let child_section_inputfields = this.getChildSections(child_section.id)
          sectioninputfields = sectioninputfields.concat(child_section_inputfields) 
        }
                
      }

      return sectioninputfields
    },
    getChildSectionsInputfields(parent_id)
    {
      let sectioninputfields = this.$store.state.evaluation.inputfields.filter((item)=>{return item.inputfieldsection_id == parent_id})      
      return sectioninputfields
      
    },
  	gotoSection()
  	{
      //console.log("section data")
      //console.log(this.data)
      
  		this.$router.push({ name: 'QuestionlistPreviewSection', params: { section_id:this.data.id } })
  	},
  }
}
</script>

<style lang="css" scoped>
</style>